var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",attrs:{"text-align:center":""}},[_c('div',{staticClass:"container content",attrs:{"text-align:center":""}},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("Image not found")])])])
}]

export { render, staticRenderFns }